var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7412_137694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 8.1748C35.2091 8.1748 37 6.38394 37 4.1748C37 1.96567 35.2091 0.174805 33 0.174805C30.7909 0.174805 29 1.96567 29 4.1748C29 6.38394 30.7909 8.1748 33 8.1748Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 10.1748H30C27.8 10.1748 26 11.9748 26 14.1748V26.1748H29V40.1748H37V26.1748H40V14.1748C40 11.9748 38.2 10.1748 36 10.1748Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.1748C6.65685 19.1748 8 17.8317 8 16.1748C8 14.518 6.65685 13.1748 5 13.1748C3.34315 13.1748 2 14.518 2 16.1748C2 17.8317 3.34315 19.1748 5 19.1748Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.1748H3C1.36 21.1748 0 22.5348 0 24.1748V32.1748H2V40.1748H8V32.1748H10V24.1748C10 22.5348 8.64 21.1748 7 21.1748Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.6748C19.933 13.6748 21.5 12.1078 21.5 10.1748C21.5 8.24181 19.933 6.6748 18 6.6748C16.067 6.6748 14.5 8.24181 14.5 10.1748C14.5 12.1078 16.067 13.6748 18 13.6748Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.6748H15.5C13.58 15.6748 12 17.2548 12 19.1748V29.1748H14.5V40.1748H21.5V29.1748H24V19.1748C24 17.2548 22.42 15.6748 20.5 15.6748Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7412_137694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.174805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupGray);
export default __webpack_public_path__ + "static/media/groupGray.fbaafc5e9cbd778d21cd8aaed3262cbb.svg";
export { ForwardRef as ReactComponent };